<template>


  <!-- <div class="login-layout md-layout md-gutter md-alignment-top-left" style="overflow: hidden"> -->
  <div style="overflow: hidden">
  <remote-check-in-form ref="RemoteCheckInForm" mode="UPDATE"/>

    <!-- <div class="md-layout-item md-size-0"></div> -->
    <div class="md-layout-item md-size-0" style="overflow: hidden">
      <form style="overflow: hidden" novalidate v-if="newPasswordForm.active" @submit.prevent="doSetNewPassword">
        <md-card-header>
          <div class="md-title">New password required</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="getValidationClass('newPasswordForm.password')">
            <label for="password">New password</label>
            <md-input name="password" id="newPassword" type="password" autocomplete="new-password" v-model="newPasswordForm.password" :disabled="sending"/>
            <span class="md-error" v-if="!$v.newPasswordForm.password.required">Password is required</span>
            <span class="md-error" v-else-if="!$v.newPasswordForm.password.minlength">Invalid password</span>
          </md-field>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending"/>

        <md-card-actions>
          <md-button type="submit" class="md-primary" :disabled="sending">Save</md-button>
        </md-card-actions>
      </form>

      <form style="overflow: hidden; border: none; border-radius: 15px; background: white" novalidate v-else-if="forgetPasswordForm.active" @submit.prevent="doForgetPassword_new(false)">
        <md-card-header>
          <div class="md-title">Reset password for {{ forgetPasswordForm.cognitoUser }}</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="getValidationClass('forgetPasswordForm.verificationCode')">
            <label for="code">Verification code</label>
            <md-input name="code" id="code" type="text" autocomplete="new-password" v-model="forgetPasswordForm.verificationCode" :disabled="sending"/>
          </md-field>

          <md-field :class="getValidationClass('forgetPasswordForm.password')">
            <label for="password">New password</label>
            <md-input name="password" id="newPassword" type="password" autocomplete="new-password" v-model="forgetPasswordForm.password" :disabled="sending"/>
            <span class="md-error" v-if="!$v.forgetPasswordForm.password.required">Password is required</span>
            <span class="md-error" v-else-if="!$v.forgetPasswordForm.password.minlength">Invalid password</span>
          </md-field>

          <md-field :class="getValidationClass('forgetPasswordForm.confirmPassword')">
            <label for="code">Retype password</label>
            <md-input name="confirmpw" id="confirmpw" type="password" autocomplete="new-password" v-model="forgetPasswordForm.confirmPassword" :disabled="sending"/>
          </md-field>

        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending"/>

        <md-card-actions>
          <md-button type="button" @click="doForgetPassword_new(true)">Resend Code</md-button>
          <calling-api :paths="['/api/w/users/me/device','/api/w/users/me']">
             <md-button type="submit" class="md-primary" :disabled="sending">Save</md-button>
          </calling-api>   
        </md-card-actions>
      </form>



      <form style="overflow: hidden; border: none; border-radius: 15px; background: white" novalidate v-else-if="mfaForm.active">
        <md-card-header>
          <div class="md-title">Multi-factor authentication for <span style="color:red">{{ loginForm.username }}</span></div>
        </md-card-header>
        <md-card-content>
          <template v-if="userMFAType == 'SMS'">
             <label class="mfa_notic">MFA authorization code has been send to your registered PHONE. Please copy the info to below.</label>
          </template>
          <template v-if="userMFAType == 'EMAIL'">
             <label class="mfa_notic">MFA authorization code has been send to your registered EMAIL. Please copy the info to below.</label>
          </template>
          <template v-if="userMFAType == 'TOTP'">
             <label class="mfa_notic">MFA authorization code is on your registered AUTHENTICATOR APP. Please copy the info to below.</label>
          </template>
          <md-field :class="getValidationClass('mfaForm.code')">
            <label for="code">MFA code</label>
            <md-input name="code" id="code" type="text" autocomplete="new-password" v-model="mfaForm.code" :disabled="sending"/>
          </md-field>
        </md-card-content>
        <div v-if="mfaerr != null && mfaerr != ''" class="errMsg">{{ mfaerr }}</div>
        <md-card-actions>
          <div class="loginBtn-pos">
             <md-button class="loginBtn" @click="loginWithMFA" :disabled="sending">Login</md-button>
          </div>
          <div class="resendBtn-pos">
             <md-button class="resendBtn" @click="resendMFACode" :disabled="userMFAType == 'TOTP'">Resend Code</md-button>
          </div>
        </md-card-actions>
        <div>
          <progress id="activeProgressBar" value="0" max="100"></progress>
        </div>
      </form>


      <form style="overflow: hidden" novalidate v-else @submit.prevent="doLogin">
        <md-card style="overflow: hidden" class="md-layout-item md-size-100">
          <div style="height: 30px"></div>
            <div class ="gcontainer">

                <div class = "item1">Remote Check-In
                  <h1 class = "Statements">We have frequently updated our web check-in portal. Please close your browser once you finish check-in, to apply the most updated function. </h1>
                  <md-card-content>
                    <md-field :class="getValidationClass('searchRequest.ibs')">
                      <label for="ibs">IBS Number</label>
                      <md-input v-model.trim="searchRequest.ibs"/>
                    </md-field>
    
                    <md-field :class="getValidationClass('searchRequest.apptNo')">
                      <label for="apptNo">Appointment Number</label>
                      <md-input v-model.trim="searchRequest.apptNo"/>
                    </md-field>

                    <md-field class="md-hide">
                      <label>Group</label>
                      <md-select v-model="loginForm.userPool" name="user-pool" id="user-pool">
                        <md-option value="acni">ACNI</md-option>
                      </md-select>
                    </md-field>
                  </md-card-content>

                  <!--<md-progress-bar md-mode="indeterminate" v-if="sending"/>-->

                  <b-notification class = "notifySize"
                                    type="is-success"
                                    v-model="notifyActive"
                                    aria-close-label="Close notification">
                                    {{notifyMessage}}
                  </b-notification>

                  <h1 class = "Statements">***** MUST READ *****</h1>
                  <h1 class = "Statements">*Do not come to the warehouse until you are called to scale.</h1>
                  <h1 class = "Statements">*Do not double park and block the roads while you await our call. </h1>
                  <h1 class = "Statements">*Find legal parking in the area.</h1>
                  <h1 class = "Statements">*Long Beach Police Department will take enforcement action against illegal parking.</h1>


                  <md-card-actions>
                    <calling-api :paths="['/api/w/users/me']">
                      <md-button class="md-primary remotecheckin" @click="doCheckin">Check-In</md-button>
                    </calling-api>
                  </md-card-actions>
                </div>
                
                <!--<md-progress-bar md-mode="indeterminate" v-if="sending" style="background-color: green;"/>-->
                <md-progress-bar md-mode="indeterminate" v-if="sending"  style="background-color: white; margin-top: -1px; height: 5px;"/>

                <div class = "item1 login-div">FSI Login
                  <md-card-content>
                    <div class="username-div">
                    <md-field :class="getValidationClass('loginForm.username')">
                      <label for="username">Username</label>
                      <md-input name="username" id="username" autocomplete="new-password" v-model="loginForm.username" :disabled="sending" tabindex="1"/>
                      <span class="md-error" v-if="!$v.loginForm.username.required">Username is required</span>
                      <span class="md-error" v-else-if="!$v.loginForm.username.minLength">Invalid username</span>
                    </md-field>
                    <div class="login-btn-div">
                     <md-card-actions>
                       <calling-api :paths="['/api/w/users/me/device','/api/w/users/me']">
                          <md-button type="submit" class="md-primary" :disabled="sending" tabindex="3"><md-icon>contacts</md-icon><span style="font-size: 17px; margin-left: 5px;">Login</span></md-button>
                       </calling-api>
                     </md-card-actions>
                    </div>


                    </div>
                    <div class="pw-div">
                    <md-field :class="getValidationClass('loginForm.password')">
                      <label for="password">Password</label>
                      <md-input name="password" id="password" type="password" autocomplete="new-password" v-model="loginForm.password" :disabled="sending" tabindex="2"/>
                      <span class="md-error" v-if="!$v.loginForm.password.required">Password is required</span>
                      <span class="md-error" v-else-if="!$v.loginForm.password.minLength">Invalid password</span>
                    </md-field>
                    </div>
                    <md-field class="md-hide">
                      <label>Group</label>
                      <md-select v-model="loginForm.userPool" name="user-pool" id="user-pool">
                        <md-option value="acni">ACNI</md-option>
                      </md-select>
                    </md-field>

 <!--
                    <div class="login-btn-div">
                     <md-card-actions>
                       <calling-api :paths="['/api/w/users/me/device','/api/w/users/me']">
                          <md-button type="submit" class="md-primary" :disabled="sending">Login</md-button>
                       </calling-api>
                     </md-card-actions>
                    </div>
                  -->
                  </md-card-content>

                  <!--<md-progress-bar md-mode="indeterminate" v-if="sending"/>-->

                  <div class="forgetpw-div">
                    <span class="forgetpw"><a href="#" @click="doForgetPassword_new(true)">Forgot Password?</a></span>
                    
                  </div>



                  <div class="contact-div">
                    <span><a href="mailto:ERPIT@acni.net" class="contact-span">Contact ACN</a></span>
                  </div>
                </div>
              </div>
        </md-card>

        <md-snackbar :md-active.sync="hasError" :md-duration="Infinity" :md-persistent="true">
          <template v-if="err">{{err.message}}</template>
        </md-snackbar>
      </form>
  
    </div>
 
    <div class="md-layout-item md-size-25"></div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-layout {
    height: 100vh;
  }

  form {
    background: white;
  }

.notifySize{
  color: red;
  background-color: yellow;
}

.gcontainer {
  display: grid;
  grid-template-columns: 1fr;
  text-align: center;
  background-color: #adacfc;
  
}

.gcontainer div {
  margin: 5px;
  /* width: 350px; */
  text-align: center;
  line-height: 25px;
  font-size: 25px;
  color: rgb(0, 17, 248);
  background-color:rgb(213, 238, 228);
}

.Statements {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: rgb(255, 0, 0);
    width: 100%;
    font-size: 16px;
    font-family: Roboto Slab;
    margin: 0;
    text-align: left;
  }

.login-div {
    border-radius: 15px;
    height: 300px;
} 
.login-btn-div {
    margin-top: -55px !important;
    /*margin-left: 50px !important;*/
    font-size: 17px !important;
    float: right;
    /*background-color:rgb(0, 17, 248) !important;*/
    /*width: 45px !important;*/
}

.forgetpw {
    font-size: 18px; 
}
.forgetpw-div {
    /*margin-top: 50px;*/
    /*margin-left: 500px;*/
    /*float: right;*/
    /*background-color: rgb(71, 179, 162) !important;*/
    /*color: white;*/
    width: 200px;
    padding: 5px;
    height: 45px;
    /*border-radius: 15px;*/
    margin-top:45px !important;
    margin-left: 35% !important; 
}
.forgetpw-div a {
  color: rgb(248, 35, 35);
  font-size: 17px;
  font-weight: bold;
}
.forgetpw-div a:hover {
  color: rgb(80, 67, 128);
}

.contact-div {
  margin-top: -40px !important;
  width: 150px;
  margin-left: 55% !important;
}

.username-div {
  width: 900px;
  margin-left: 25% !important; 
  margin-top: 30px !important; 
  /*padding: 0.5px;*/
}
.pw-div {
  width: 900px;
  margin-left: 25% !important;  

}
.contact-span {
  font-size: 20px !important;
  margin-top: -5px;
}
.remotecheckin {
  margin-left: -1200px !important;
  margin-top: -190px !important;
  /*position: absolute !important;*/
}

.progress-container {
   width: 80%;
   max-width: 400px;
   text-align: center;
}
progress {
  width: 100%;
  height: 10px;
  appearance: none;
  border: none;
  border-radius: 5px;
  background-color: #e0e0e0;
}
progress::webkit-progress-bar {
  background-color: #e0e0e0;
  border-radius: 5px;
}
progress::webkit-progress-value {
  background-color: #4CAF50;
  border-radius: 5px;
}
progress::-moz-progress-bar {
  background-color: #4CAF50;
  border-radius: 5px;
}
.resendBtn {
  background-color: #3d5ce757;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 12px;
}
.loginBtn {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 12px;
  font-weight: bolder;
}
.loginBtn-pos {
  margin-top: -145px;
  margin-right: 65%;
}
.resendBtn-pos {
  margin-left: -300px !important;
}

</style>


<script>
  import { validationMixin } from 'vuelidate'
  import { Amplify } from 'aws-amplify';
  import { signIn, confirmSignIn, resendSignUpCode } from 'aws-amplify/auth';
  import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
  import { getCurrentUser, forgotPasswordSubmit, forgotPassword } from 'aws-amplify/auth';
  import { signOut } from 'aws-amplify/auth';
  import { rememberDevice } from 'aws-amplify/auth';
  import { verifyTOTPSetup, updateMFAPreference, fetchMFAPreference } from 'aws-amplify/auth';
  import Config from '../config';
  import { newAPIPost } from '../api/index.js';
  import awsmobile from '../aws-exports';
  import { mapGetters } from 'vuex';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import RemoteCheckInForm from '../components/RemoteCheckInForm.vue';

  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'


  const getInitSearch = () => ({
    ibs_types: [],
    ibs : null,
    receivingWindows : null,
    checkIn : null,
    username : null,
    inboundSeq : null,
    inboundStatus : null,
    block : null,
    apptNo : null,
    apptDate : null,
    externalTrucker : null,

  });


  export default {
    mixins: [validationMixin],
    data: () => ({
      searchRequest: getInitSearch(),
      ibsinbound: [],
      loginForm: {
        username: null,
        password: null,
        userPool: 'acni',
      },
      newPasswordForm: {
        active: false,
        password: null,
        cognitoUser: null,
      },
      hasError: false,
      err: null,
      sending: false,
      awsConfig: null,
      appLinks: Config.appLinks,
      notifyActive: false,
      notifyMessage: " ",
      newPasswordForm: {
        active: false,
        password: null,
        cognitoUser: null
      },
      forgetPasswordForm: {
        active: false,
        password: null,
        confirmPassword: null,
        cognitoUser: null,
        verificationCode: null
      },
      mfaForm: {
        active: false,
        user: null,
        code: null
      },
      mfaerr: null,
      sending: false,
      awsConfig: null,
      appLinks: Config.appLinks,
      userMFAType: null,
      userObj: null,
    }),

    components: {
      RemoteCheckInForm,
      callingApiCenter,
    },

    watch: {
    
    },

    computed: {
    ...mapGetters([
        'getibsInbound',
      ]),
    },

    validations: {
      loginForm: {
        username: {
          required,
          minLength: minLength(3)
        },
        password: {
          required,
          minLength: minLength(8)
        },
      },
      newPasswordForm: {
        password: {
          required,
          minLength: minLength(8)
        },
      },
      forgetPasswordForm: {
        password: {
          required,
          minLength: minLength(8)
        },
      }

    },
    methods: {
      getValidationClass(fieldName) {
        const field = _(this.$v).lookup(fieldName)

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      async doLogin() {
        this.$v.loginForm.$touch();

        if (this.loginForm.username == "REMOTECHECKIN") {
          return;
        }

        if (this.$v.loginForm.$invalid) {
          return;
        }

        this.awsConfig = Config.awsConfigs[this.loginForm.userPool];
        console.log(`awsConfig=${JSON.stringify(this.awsConfig)}`);
        const mergedConfig = _(awsmobile).extend(this.awsConfig);
        console.log(`mergedConfig`, mergedConfig);
        Amplify.configure(mergedConfig);

        this.sending = true;
        this.hasError = false;

        //Auth.signIn(this.loginForm.username, this.loginForm.password).then(cognitoUser => {
        console.log('calling signin');
        try
        {
          var p_username = this.loginForm.username;
          var p_password = this.loginForm.password;
          console.log('sign in user:', p_username);
          console.log('check login user.');
          this.checkUserSession();
          await signOut({ global: true });
          const user = await signIn({username: p_username,password: p_password});
          this.sending = false;
          this.userObj = user;
          console.log('signin user:', JSON.stringify(user));
          if (user.isSignedIn && user.nextStep.signInStep == 'DONE')
          {
             const signindetails = await getCurrentUser();
             console.log('signindetails:',JSON.stringify(signindetails));
             this.checkUserMFASetting(p_username, p_password);
             //this.handleLoggedIn_new();
          } else if (user && user.nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE')
          {
              console.log('nextStep.codeDeliveryDetails.deliveryMedium:',user.nextStep.codeDeliveryDetails.deliveryMedium);
              if (user.nextStep.codeDeliveryDetails.deliveryMedium == 'EMAIL')
              {
                 //this.checkUserMFASetting(p_username, p_password, 'EMAIL');
                 this.userMFAType = "EMAIL";
                 this.mfaForm.active = true;
              }
          }
          else if (user && user.nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_TOTP_CODE')
          {
             //console.log('nextStep.codeDeliveryDetails.deliveryMedium:',user.nextStep.codeDeliveryDetails.deliveryMedium);
             // if (user.nextStep.codeDeliveryDetails.deliveryMedium == 'TOTP')
             // {
                 //this.checkUserMFASetting(p_user, p_password, 'TOTP');
                 this.userMFAType = "TOTP";
                 this.mfaForm.active = true;
             // }              
          }
          else if (user && user.nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_SMS_CODE')
          {
                this.userMFAType = "SMS";
                this.mfaForm.active = true;
          }
          else if (user && user.nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED')
          {
                this.newPasswordForm.active = true;
          }
        } catch (err)
        {
           console.log('Sign in error:', err);
           this.sending = false;
           this.hasError = true;
           this.err = err; 
        }
        // await signIn({username, password}).then(cognitoUser => {
        //   this.sending = false;
        //   console.log('cognitoUser:',cognitoUser);
        //   this.userObj = cognitoUser;

        //   if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
        //     this.newPasswordForm.active = true;
        //     this.newPasswordForm.cognitoUser = cognitoUser
        //   } else {
        //     //this.handleLoggedIn();
        //     if (cognitoUser.challengeName == 'SMS_MFA' || cognitoUser.challengeName == 'SOFTWARE_TOKEN_MFA')
        //     {
        //       this.userMFAType = cognitoUser.challengeName;
        //       this.mfaForm.active = true;
        //     } else {
        //       this.handleLoggedIn();
        //     }
        //   }

        // }).catch(err => {
        //   console.log(err);
        //   this.sending = false;
        //   this.hasError = true;
        //   this.err = err;
        // });
      },

      async updateMFAMethod()
      {
         const path = '/api/w/users';
         const loginuser = this.loginForm.username;
         //const p_appname = 'OSAP';
         try {
            const response = await newAPIPost(path, {fromUsername: loginuser, toUsername: loginuser});
            if (response && response.length > 0)
            {
               if (response[0].loginWithMFA == true && response[0].mfaMethod != null)
               {
                  if (response[0].mfaMethod == 'EMAIL') {
                      //await updateMFAPreference({ sms: {enabled: false}});
                      //await updateMFAPreference({ totp: {enabled: false}});
                      //await updateMFAPreference({ email: {enabled: true, preferred: true}});
                      await updateMFAPreference({ email: 'PREFERRED'});
                  }
                  if (response[0].mfaMethod == 'TOTP') {
                      //await updateMFAPreference({ sms: {enabled: false}});
                      //await updateMFAPreference({ email: {enabled: false}});
                      //await updateMFAPreference({ totp: {enabled: true, preferred: true}});
                      await updateMFAPreference({ totp: 'PREFERRED'});
                  }
                  if (response[0].mfaMethod == 'SMS') {
                      //await updateMFAPreference({ email: {enabled: false}});
                      //await updateMFAPreference({ totp: {enabled: false}});
                      //await updateMFAPreference({ sms: {enabled: true, preferred: true}});
                      await updateMFAPreference({ sms: 'PREFERRED'});
                  }
               }
            }  
         } catch (err) {
            console.log(`Error on updating MFA method in cognito, ${err}`);
         }
      },

      async checkUserMFASetting(username, password, cog_mfa_method)
      {
         try {
           const path = '/api/w/users';
           const loginuser = this.loginForm.username;
           try {
              console.log('calling api checkusermfasetting');
              //const response = await newAPIPost(path, { username: loginuser });
              const response = await newAPIPost(path, {fromUsername: loginuser, toUsername: loginuser});
              console.log('Post successful:',JSON.stringify(response));
              if (response && response.length > 0)
              {
                  if (response[0].loginWithMFA == true && response[0].mfaMethod != null)
                  {
                      if (response[0].mfaMethod == 'EMAIL')
                      {
                         if (cog_mfa_method != 'EMAIL') {
                            try {
                              await updateMFAPreference({ email: 'PREFERRED'});
                              await signOut({ glodbal: true});
                              await signIn({username, password});
                              this.userMFAType = "EMAIL";
                              this.mfaForm.active = true;
                            } catch (err)
                            {
                               console.log(`Error on setting up preferred email, ${err}`); 
                            }
                         } else {
                            this.userMFAType = 'EMAIL';
                            this.mfaForm.active = true;
                         }

                      }
                      if (response[0].mfaMethod == 'TOTP') {
                         if (cog_mfa_method != 'TOTP')
                         {
                           this.userMFAType = "TOTP";
                           this.handleLoggedIn_new(); 
                         } else {
                           this.userMFAType = "TOTP";
                           this.mfaForm.active = true;
                         }
                      }
                      if (response[0].mfaMethod == 'SMS') {
                         if (cog_mfa_method != 'SMS')
                         {
                            this.userMFAType = "SMS";
                            this.handleLoggedIn_new();
                         } else {
                            this.userMFAType = "SMS";
                            this.mfaForm.active = true;
                         }
                      }  

                  } else {
                     this.handleLoggedIn_new();
                  }
              } else {
                 console.log(`has no response!`)
              }
              //console.log('Post successful');
          } catch (err)
          {
             console.log('Error calling api checkusermfasetting: ', err)
          }             

         } catch (err) {

         }
      },

      async checkUserSession() {
         try {
           const { checkuser } = await getCurrentUser();
           if (checkuser != null) {
             console.log(`user ${checkuser} is already signed in`);
             await signOut({global: true});  
           }
         } catch (err) 
         {
            console.log('No user currently signed in, processing with sign-in.');
         }
      },

      async resendMFACode()
      {
         const p_username = this.loginForm.username;
         const p_password = this.loginForm.password;
         try {
            const user = await signIn({username: p_username,password: p_password});
            console.log(`MFA code resent successfully`, JSON.stringify(user)); 
            alert('Code is resent');
         } catch (err) {
           console.log(`Error on resending MFA code, ${err}`); 
         }

      },

      async doSetNewPassword() {
        this.$v.newPasswordForm.$touch();

        if (this.$v.newPasswordForm.$invalid) {
          return;
        }

        this.sending = true;
        this.hasError = false;
        const userAttributes = { };
        const newpassword = this.newPasswordForm.password;
        try {
           const { isSignedIn } = await confirmSignIn({challengeResponse: newpassword,
               options: {
                  userAttributes
               }
           });
           if (isSignedIn) {
              console.log(`Successfully signed in with a new password!`);
              this.sending = false;
              this.handleLoggedIn_new();
           } else {
              console.log(`New password sing-in failed unexpected`);
           }
        } catch (err) {
            console.log(`Error in confirming new password: ${err}`);
            this.sending = false;
            this.hasError = true;
            this.err = err;   
        }

        ////Auth.completeNewPassword(this.newPasswordForm.cognitoUser, this.newPasswordForm.password, {})
        // completeNewPassword(this.newPasswordForm.cognitoUser, this.newPasswordForm.password, {})
        //   .then(res => {
        //     this.sending = false;
        //     this.handleLoggedIn();
        //   })
        //   .catch(err => {
        //     console.log(err);
        //     this.sending = false;
        //     this.hasError = true;
        //     this.err = err;
        //   });
      },

      async handleLoggedIn_new() {
        await rememberDevice();
          const saveDeviceAndLogin = () => {
            //localStorage.setItem("deviceKey", deviceKey);
            newAPIPost('/api/w/users/me/device', {}).then(() => {
              this.$store.dispatch(
                'userLoggedIn',
                {
                  awsConfig: this.awsConfig
                }
              );
            });
          };

        const path = '/api/w/users/me';
        const loginuser = this.loginForm.username;
        try {
          console.log('calling api');
          //const response = await newAPIPost(path, { username: loginuser });
          const response = await newAPIPost(path, {});
          console.log('Post successful:',JSON.stringify(response));
          this.updateMFAMethod();
          saveDeviceAndLogin();
          //console.log('Post successful');
        } catch (err)
        {
           console.log('Error calling api: ', err)
        }  
      },

      handleLoggedIn() {
        //Auth.currentAuthenticatedUser().then((cognitoUser) => {
        currentAuthenticatedUser().then((cognitoUser) => {
          cognitoUser.getCachedDeviceKeyAndPassword();
          const { deviceKey } = cognitoUser;

          const saveDeviceAndLogin = () => {
            localStorage.setItem("deviceKey", deviceKey);
            //api.post('/api/w/users/me/device', {}).then(() => {
            newAPIPost('/api/w/users/me/device', {}).then(() => {  
              this.$store.dispatch(
                'userLoggedIn',
                {
                  awsConfig: this.awsConfig
                }
              );
            });
          };

          //this.doSetupTOTP();
          
          //api.post('/api/w/users/me', {}).then((userProfile) => {
          newAPIPost('/api/w/users/me', {}).then((userProfile) => {  
            console.log(`current deviceKey = ${deviceKey}`);
            console.log(`userProfile deviceKey = ${userProfile.currentDeviceKey}`);
            if (!!userProfile.currentDeviceKey && userProfile.currentDeviceKey != deviceKey) {
              if (window.confirm("There's another logged in session, do you want to kick the logged in session and login?")) {
                saveDeviceAndLogin();
              } else {
                this.$store.dispatch('logout');
              }
            } else {
              saveDeviceAndLogin();
            }
          });
        });
      },


      async doCheckin() {

        if (this.searchRequest.ibs == null) {
          return;
        }
 
        this.loginForm.username = "XXXXXXX"
        this.loginForm.password = "XXXXXXX" 
 
        this.awsConfig = Config.awsConfigs[this.loginForm.userPool];
        console.log(`awsConfig=${JSON.stringify(this.awsConfig)}`);
        const mergedConfig = _(awsmobile).extend(this.awsConfig);
        console.log(`mergedConfig`, mergedConfig);
        Amplify.configure(mergedConfig);

        this.sending = true;
        this.hasError = false;

        const p_remotecheckinusername = 'REMOTECHECKIN';
        const p_remotecheckpassword = '123123123';
        try {
          //this.checkUserSession();
          signOut({global: true});
          const remotecheckuser = await signIn({username: p_remotecheckinusername, password: p_remotecheckpassword});
          this.sending = false;
          this.userObj = remotecheckuser;
          console.log(`signin remote checkin user: ${JSON.stringify(remotecheckuser)}`);
          if (remotecheckuser.isSignedIn && remotecheckuser.nextStep.signInStep == 'DONE')
          {
              const remotechecksignindetails = await getCurrentUser();
              console.log(`remote checkin signindetails: ${JSON.stringify(remotechecksignindetails)}`);
              this.handleCheckIn();
          }         
        } catch (err)
        {
           console.log(`Remote checkin signin error: ${err}`);
           this.sending = false;
           this.hasError = true;
           this.err = err;
        }

        // //Auth.signIn('REMOTECHECKIN', '123123123').then(cognitoUser => {
        // signIn('REMOTECHECKIN', '123123123').then(cognitoUser => {
        //   this.sending = false;
        //   console.log(cognitoUser);

        //   if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
        //     this.newPasswordForm.active = true;
        //     this.newPasswordForm.cognitoUser = cognitoUser
        //   } else {
        //     this.handleCheckIn_new();
        //   }

        // }).catch(err => {
        //   console.log(err);
        //   this.sending = false;
        //   this.hasError = true;
        //   this.err = err;
        // });
      },

      async doSetupTOTP()
      {
         console.log(`calling dosetuptotp`);
         const user = await Auth.currentAuthenticatedUser();
         const secretCode = await Auth.setupTOTP(user);
         const issuer = "ACNI";
         const username = user.username;
         const otpauthUrl = `otpauth://totp/${issuer}:${username}?secret=${secretCode}&issuer=${issuer}`;
         console.log(`secretcode: ${secretCode}`);
         console.log(`otpauth: ${otpauthUrl}`);
      },

      async doForgetPassword_new(sendcode) {
         console.log(`login form username: ${this.loginForm.username}`);
         if (this.loginForm.username == null || this.loginForm.username == '')
         {
            alert("Please input username");
            return;
         }

         this.awsConfig = Config.awsConfigs[this.loginForm.userPool];
         console.log(`awsConfig=${JSON.stringify(this.awsConfig)}`);
         const mergedConfig = _(awsmobile).extend(this.awsConfig);
         console.log(`mergedConfig`, mergedConfig);
         Amplify.configure(mergedConfig);

         this.sending = true;
         this.hasError = false;
         const loginusername = this.loginForm.username;
         this.forgetPasswordForm.active = false;
         if (sendcode) {
           try {
             console.log(`reset password user: ${loginusername}`);
             const output = await resetPassword({ username: loginusername });
             const { nextStep } = output;
             console.log(`Code sent to: ${nextStep.codeDeliveryDetails.deliveryMedium}`);
             this.sending = false;
             alert("Reset password verification code send to registered email."); 
           } catch (err) {
              console.log(`Error initiating password reset: ${err}`);
              this.sending = false;
              this.hasError = true;
              if (err.code && err.code != '')
              {
                  if (err.code == 'UserNotFoundException')
                     this.err = "User not existed!!";
                  else 
                     this.err = "Encounter error while resetting password";  
              }
           }
         }
         else {
            if (this.forgetPasswordForm.password != this.forgetPasswordForm.confirmPassword)
            {
               this.hasError = true;
               this.err = "Password and Confirm password need to be idential!";
               alert("Password and Confirm password need to be idential!");  
            }
            if (!this.forgetPasswordForm.verificationCode || this.forgetPasswordForm.verificationCode == '')
            {
               this.hasError = true;
               this.err = "Verification code is required!";
               alert("Verification code is required!");
            } 
            if (!this.hasError)
            {
               const p_code = this.forgetPasswordForm.verificationCode.trim();
               const p_newpassword = this.forgetPasswordForm.password;
               console.log(`forgetpw p_code: ${p_code}`);
               try {
                 await confirmResetPassword({ username: loginusername, confirmationCode: p_code, newPassword: p_newpassword});
                 this.sending = false;
                 console.log(`the new password submitted successfully!`);
                 alert("the new password submitted successfully!"); 
               } catch (err) {
                 this.sending = false;
                 this.hasError = true;
                 if (!err.message)
                 {
                    console.log(`Error while confirming new password: ${err}`);
                    this.err = err; 
                 } else {
                    console.log(`Error while confirming new password: ${err.message}`);
                    this.err = err.message;
                 }
               } 
            }
         }
         console.log(`this.hasError: ${this.hasError}`);
         if (!this.hasError) {
            this.sending = false;
            if (sendcode)
               this.forgetPasswordForm.active = true;
         } else {
            alert(`Encounter error: ${this.err}`);
         }
      },

      async doForgetPassword(sendcode) {
        // this.$v.forgetPasswordForm.$touch();

        // if (this.$v.forgetPasswordForm.$invalid) {
        //   return;
        // }

        console.log(`loginform username: ${this.loginForm.username}`);
        if (this.loginForm.username == null || this.loginForm.username == "")
        {
           alert("Please input username");
           return;
        }

        this.awsConfig = Config.awsConfigs[this.loginForm.userPool];
        console.log(`awsConfig=${JSON.stringify(this.awsConfig)}`);
        const mergedConfig = _(awsmobile).extend(this.awsConfig);
        console.log(`mergedConfig`, mergedConfig);
        Amplify.configure(mergedConfig);

        this.sending = true;
        this.hasError = false;
        this.forgetPasswordForm.active = false;
        //Auth.forgotPassword(this.newPasswordForm.cognitoUser)
        if (sendcode) {
          //await Auth.forgotPassword(this.loginForm.username,{})
          await forgotPassword(this.loginForm.username,{})
             .then(data => {
               this.sending = false;
               console.log(`forget pw data: ${JSON.stringify(data)}`);
               alert("Reset password verification code send to registered email.");
             })
             .catch(err => {
               this.sending = false;
               this.hasError = true;
               if (err.code && err.code != "")
               {
                  if (err.code == "UserNotFoundException")
                     this.err = "User not exist!!";
                  else 
                  {
                     if (err.message)
                        this.err = JSON.stringify(err.message);
                     else
                        this.err = "Encounter error while process reset password!"; 
                  }      
               }
               //this.err = err;
               console.log(`forget pw err: ${JSON.stringify(err)}`);
             })
        }
        else {
          if (this.forgetPasswordForm.password != this.forgetPasswordForm.confirmPassword)
          {
              this.hasError = true;
              this.err = "Password and confirm password need idential!";
              alert("Password and confirm password need idential!");
              //return;
          }
          if (!this.forgetPasswordForm.verificationCode || this.forgetPasswordForm.verificationCode == "")
          {
              this.hasError = true;
              this.err = "Verification code is required!";
              alert("Verification code is required!");
              //return;
          }
          if (!this.hasError)
          {
             const p_code =  this.forgetPasswordForm.verificationCode.trim();
             console.log(`forgetpw p_code: ${p_code}`);
             //await Auth.forgotPasswordSubmit(this.loginForm.username, p_code, this.forgetPasswordForm.password)
             await forgotPasswordSubmit(this.loginForm.username, p_code, this.forgetPasswordForm.password)
               .then( () => {
                 this.sending = false;
                 console.log("the new password submitted successfully!"); 
                 alert("the new password submitted successfully!");
               })
               .catch(err => {
                 this.sending = false;
                 this.hasError = true;
                 if (!err.message)
                 {
                    console.log(`Error while confirming new password: ${err}`);
                    //alert(`Error while confirming new password: ${err}`);
                    this.err = err;
                 } else {
                    console.log(`Error while confirming new password: ${err.message}`);
                    //alert(`Error while confirming new password: ${err.message}`);
                    this.err = err.message;
                  
                 }
               })
          }    
          
        }
        console.log(`this.hasError: ${this.hasError}`);
        if (!this.hasError) {    
           this.sending = false; 
           if (sendcode)
              this.forgetPasswordForm.active = true;
        } else {
           alert(`Encounter error: ${this.err}`);
        }
      },

      async loginWithMFA() {
         this.updateProgress(0);
         const code = await this.getCodeFromUserInput();
         this.updateProgress(30);
         const mfaType = await this.getMFATypeFromUserInput();
         this.updateProgress(60);
         const p_user = this.userObj;
         this.sending = true;
         this.hasError = false;
         this.mfaerr = "";

         try
         {
            
            const { isSignedIn, nextStep } = await confirmSignIn({challengeResponse: code});
            console.log('User confirmed MFA and signed in:', isSignedIn);
            console.log('confirm signin nextstep:',nextStep);
            this.updateProgress(100);
            this.handleLoggedIn_new();
         } catch(err)
         {
            console.log('Error confirming MFA:',err);
            this.sending = false;
            this.hasError = true;
            this.mfaerr = err.message;
         }

        //  //const loggedUser = await Auth.confirmSignIn(
        //  const loggedUser = await confirmSignIn(
        //           p_user,
        //           code,
        //           mfaType
        //  )
        //  .then(res => {
        //      console.log(`loggedUser: ${loggedUser} ${code} ${mfaType}`);
        //      this.handleLoggedIn();
        //  })
        //  .catch(err => {
        //      console.log(`MFA login failed with Error: ${JSON.stringify(err)}`);
        //      this.sending = false;
        //      this.hasError = true;
        //      this.mfaerr = err.message;
        //  });
        //  //console.log(`loggedUser: ${loggedUser} ${code} ${mfaType}`);
        //  //this.handleLoggedIn();

      },

      async getCodeFromUserInput() {
          return this.mfaForm.code; 
      },

      async getMFATypeFromUserInput() {
          return this.userMFAType;
      },

      async handleCheckIn() {
          this.notifyActive = false
          this.notifyMessage = " "

          //api.post('/api/w/users/me', {}).then((userProfile) => {
          newAPIPost('/api/w/users/me', {}).then((userProfile) => {  
            console.log(`userProfile  = ${userProfile}`);     
          });

          
          this.searchRequest.inboundStatus = "O"
          const search = this.searchRequest;
          //const result = await api.post('/api/w/fsi/GetIBSInbound', search);
          const result = await newAPIPost('/api/w/fsi/GetIBSInbound', search);
          const request = result[0];
          
          var appN = search.apptNo;
          var APPN = appN.toUpperCase();

          if ( request == undefined){
            this.searchRequest.inboundStatus = "C"
            //const result = await api.post('/api/w/fsi/GetIBSInbound', search);
            const result = await newAPIPost('/api/w/fsi/GetIBSInbound', search);
            const request = result[0];
            if ( request == undefined){
              this.notifyActive = true
              this.notifyMessage = "IBS/Appointment Number not match!!" 
            }
            else{
              if ( APPN == request.apptNo ){
                this.$refs.RemoteCheckInForm.openDialog(request);
              }
              else{
                this.notifyActive = true
                this.notifyMessage = "IBS/Appointment Number not match!!" 
              }
            }
          }
          else{
            if ( APPN == request.apptNo ){
            this.$refs.RemoteCheckInForm.openDialog(request);
            }
            else{
              this.notifyActive = true
              this.notifyMessage = "IBS/Appointment Number not match!!" 
            }
          } 
      },
      updateProgress(newValue) {
          const progressBar = document.getElementById('activeProgressBar');
          if (progressBar != null)
          {
             progressBar.value = newValue;
          }
      },
    }
  };


</script>

